export default class OurTeamPage {
  constructor() {
    this.tabItems = $(".js-team-tab-switch-item");
    this.teamMembers = $(".js-team-member");
    this.mobileWidth = 768;
  }

  init() {
    this.handleEvents();
  }

  filterBySection(section) {
    this.teamMembers.each(function () {
      const $member = $(this);
      const memberSection = $member.data("section");

      memberSection === section ? $member.show() : $member.hide();
    });
  }

  handleEvents() {
    this.tabItems.on("click", (event) => {
      const $tabItem = $(event.currentTarget);
      const tabSection = $tabItem.data("section");

      tabSection === "all" ? this.teamMembers.show() : this.filterBySection(tabSection);
    });

    window.onresize = () => {
      const tabItemAll = this.tabItems.filter((index, element) => {
        return $(element).data("section") === "all";
      });

      if (window.innerWidth <= this.mobileWidth) {
        this.teamMembers.show();
        this.tabItems.removeClass("active in");
        tabItemAll.addClass("active in");
      }
    };
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const ourTeamPage = new OurTeamPage();
  ourTeamPage.init();
});
